<template>
  <div class="max-w-[1100px] w-full mx-auto bg-[#FFC519] justify-between u-center p-4 sm:p-6 flex flex-col sm:flex-row sm:rounded-xl">
    <div class="text-[19px] sm:text-24 text-black font-semibold mb-4 sm:mb-0">{{ $t('game.react-emoji') }}</div>
    <div class="flex flex-col">
      <div class="flex space-x-4 sm:space-x-3">
        <div
          v-for="(badge, i) in badges"
          :id="badge.id + 'background'"
          :key="i"
          :class="isMobile ? 'w-9 h-[52.5px]' : 'w-12 h-[70px]'"
          class="outline-none u-center flex flex-col cursor-pointer"
        >
          <div
            :class="getCurrentUserReactions().includes(badge.id) ? 'bg-[#19B44E]' : 'bg-white'"
            class="z-3 relative rounded-full w-9 h-9 sm:w-12 sm:h-12 u-center"
            @click="handleReaction(badge.id)"
          >
            <OIcon
              :id="badge.id"
              :ref="badge.id"
              icon="plus-one"
              svg-class="absolute z-[-50] w-7 h-7"
              :svg-style="
                getCurrentUserReactions().includes(badge.id)
                  ? 'top: -18px; left: -15px; transition-duration: 300ms;'
                  : 'top: 4px; left: 4px; visibility: hidden;'
              "
            />
            <img :src="badge.icons.gif" class="w-[24.4px] h-[24.4px] sm:w-[32.5px] sm:h-[32.5px]" loading="lazy" />
          </div>
          <div class="leading-18 text-13 font-normal text-primary-200 mt-[3px]">
            {{ reactions[[`game:${gameId}:reaction:${badge.id}`]] }}
          </div>
        </div>
      </div>
      <div v-if="showWarning" class="basis-full text-red-500 text-center text-sm -ml-3 mt-4">
        {{ $t('news-page.emoji-reaction-limit') }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, useContext, onMounted } from '@nuxtjs/composition-api';
import axios from 'axios';
import { COUNTERS_LAMBDA_URL } from '@/constants/config';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';
import { useDialog } from '~/composables/useModal';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    gameId: Number,
  },
  setup(props) {
    const { $service } = useContext();
    const { isMobile } = useDevice();
    const { openErrorDialog } = useDialog();
    const userReactions = ref({});
    const isReactionsDisabled = ref(false);
    const showWarning = ref(false); // computed refactor
    const { auth } = useAuth();
    const userId = auth.value.isLoggedIn ? auth.value.user._id : 'anonym';
    const storageUserKey = `u${userId}`;

    const badges = [
      {
        id: '1f60c',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/d4cadedb61a2db8bc8c5c369028cc4ffa4966c51d2d2c75f8e6167c07e1ba3e1.gif',
        },
      },
      {
        id: '1f44e',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/61333d24ca3819629e766cd21fa68c38d73deff54d0003e1107b46884d431b44.gif',
        },
      },
      {
        id: '1f44f',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/7213a0b115f88320a222b14c5daa3596729b9ec93f710da3d2f8b5a6004e9aba.gif',
        },
      },
      {
        id: '1f625',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/1ab646d43efac881b74c9a41fa443ad7d97cdf5ad591a5f14b4178702464eeaa.gif',
        },
      },
      {
        id: 'emoj.kizgin',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/afa6da55313299c3cd21249bc1c596c5f6fc04de4152c1543c63a648353b99c1.gif',
        },
      },
      {
        id: '1f602',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/9c889ddd1664e0e9e8fc1c93e8316503acd7c5c94cd4cdab3d3161f4e3a227f1.gif',
        },
      },
      {
        id: '1f631',
        icons: {
          gif: 'https://srv-cdn.onedio.com/store/8fd2ed53959eb901230be656a889da9518a36cd2a78ab38888963c79e26415c5.gif',
        },
      },
    ];

    const reactions = ref({
      [`game:${props.gameId}:reaction:1f60c`]: 0,
      [`game:${props.gameId}:reaction:1f44e`]: 0,
      [`game:${props.gameId}:reaction:1f44f`]: 0,
      [`game:${props.gameId}:reaction:1f625`]: 0,
      [`game:${props.gameId}:reaction:1f625`]: 0,
      [`game:${props.gameId}:reaction:emoj.kizgin`]: 0,
      [`game:${props.gameId}:reaction:1f602`]: 0,
      [`game:${props.gameId}:reaction:1f631`]: 0,
    });

    const getReactions = async () => {
      const keys = [
        `game:${props.gameId}:reaction:1f60c`,
        `game:${props.gameId}:reaction:1f44e`,
        `game:${props.gameId}:reaction:1f44f`,
        `game:${props.gameId}:reaction:1f625`,
        `game:${props.gameId}:reaction:1f625`,
        `game:${props.gameId}:reaction:emoj.kizgin`,
        `game:${props.gameId}:reaction:1f602`,
        `game:${props.gameId}:reaction:1f631`,
      ];
      const { data: resultReaction } = await axios.get(`${COUNTERS_LAMBDA_URL}/batch?keys=` + keys.toString());
      const entries = Object.entries(resultReaction);
      entries.map(([key, val]) => {
        reactions.value[key] = val;
      });
      badges.sort((a, b) => {
        const id = `game:${props.gameId}:reaction:${a.id}`;
        const id2 = `game:${props.gameId}:reaction:${b.id}`;
        return reactions.value[id2] - reactions.value[id];
      });
    };

    const handleReaction = async (reactionId) => {
      const id = `game:${props.gameId}:reaction:${reactionId}`;
      if (isReactionsDisabled.value) return;
      isReactionsDisabled.value = true;
      try {
        if (getCurrentUserReactions().includes(reactionId)) {
          if (getCurrentUserReactions().length <= 3) {
            showWarning.value = false;
          }
          await $service.game.removeReaction(props.gameId, reactionId);
          removeReactionStorage(reactionId);
          reactions.value[id]--;
        } else {
          if (getCurrentUserReactions().length === 3) {
            showWarning.value = true;
            return;
          }
          await $service.game.addReaction(props.gameId, reactionId);
          addReactionStorage(reactionId);
          reactions.value[id]++;
        }
      } catch (error) {
        openErrorDialog({ error });
      } finally {
        isReactionsDisabled.value = false;
      }
    };

    onMounted(() => {
      getReactions();
      userReactions.value = localStore.getItem('o-rcts');
      if (!userReactions.value) {
        userReactions.value = {};
        localStore.setItem('o-rcts', userReactions.value);
      }
      if (!userReactions.value[storageUserKey]) {
        userReactions.value[storageUserKey] = {};
        localStore.setItem('o-rcts', userReactions.value);
      }
    });

    const getCurrentUserReactions = () => {
      if (process.server) return [];
      const result = localStore.getItem('o-rcts')?.[storageUserKey]?.[props.gameId];
      return result || [];
    };

    const addReactionStorage = (id) => {
      const newReactions = [...getCurrentUserReactions(), id];
      userReactions.value[storageUserKey][props.gameId] = newReactions;
      localStore.setItem('o-rcts', userReactions.value);
    };

    const removeReactionStorage = (id) => {
      const newReactions = getCurrentUserReactions().filter((itemId) => itemId !== id);
      userReactions.value[storageUserKey][props.gameId] = newReactions;
      localStore.setItem('o-rcts', userReactions.value);
    };

    return {
      isMobile,
      badges,
      reactions,
      showWarning,
      handleReaction,
      getCurrentUserReactions,
    };
  },
});
</script>
